module.exports = __webpack_public_path__ + "img/project.013663a9.png";